import React, { useContext, useEffect, useState } from 'react';
import './Lots.css';
import { FirebaseContext } from '../../../context/firebase';
import Calendar from 'react-calendar';
import { CircularProgress, makeStyles } from '@material-ui/core';
import * as PROJECT_CODE from '../../../constants/projectCode';
import siteplan from '../../../assets/siteplan.jpg';
import ImageMapper from 'react-img-mapper';
import { useLocation } from 'react-router';
import { SetLotToAvailable } from '../setLotToAvailable';
import CloseIcon from '@material-ui/icons/Close';
import StopIcon from '@material-ui/icons/Stop';
import { legendData } from '../../siteplan/legend.data';
import { connect } from 'react-redux';

function Lots({
	setLotList,
	setBuildingPriceSum,
	setLotPriceSum,
	setLotPrice,
	setIsCompleted,
	lotActive,
	setLotActive,
	setDisable,
	disable,
	userType,
	userDetails,
}) {
	const { firebase } = useContext(FirebaseContext);
	const [mapCoords, setMapCoords] = useState({
		name: 'my-map',
	});
	const [hoveredArea, setHoveredArea] = useState();
	const [stayHighlighted, setStayHighlighted] = useState(true);
	const [clickLotInfo, setClickLotInfo] = useState();
	const [show, setShow] = useState(false);
	const location = useLocation();

	const useStyles = makeStyles((theme) => ({}));

	const styles = useStyles();

	const handleClearLotInfo = async (lot) => {
		await SetLotToAvailable(firebase, PROJECT_CODE.projectCode, lot);

		setEmptyLot();
		setDisable({ ...disable, lots: true });
	};

	const setEmptyLot = async () => {
		await setLotActive({});
	};

	//setting up the map
	useEffect(() => {
		async function getData() {
			await firebase
				.database()
				.ref('/kavtek_clients/' + PROJECT_CODE.projectCode + '/lots')
				.on('value', (snapshot) => {
					var mapCoordObj;
					var areaArr = [];
					snapshot.forEach((lot) => {
						var mapCoordVal = lot.val().mapCoords;

						areaArr.push(mapCoordVal);

						if (userType === 'cobroker') {
							if (lot.val()?.coBroker == userDetails.email) {
								if (lot.val().available === 'soldout') {
									mapCoordVal['preFillColor'] =
										'rgba(255, 0, 0, 0.47)';
								}
								if (lot.val().available === 'available') {
									mapCoordVal['preFillColor'] = '';
								}
								if (lot.val().available === 'pending') {
									mapCoordVal['preFillColor'] =
										'rgba(255, 255, 168, 0.70)';
								}
								if (lot.val().available === 'hold') {
									mapCoordVal['preFillColor'] =
										'rgba(97, 97, 97, 1)';
									mapCoordVal['disabled'] = true;
								}
							} else {
								mapCoordVal['preFillColor'] = '#ccc';
								mapCoordVal['disabled'] = true;
							}
						} else {
							if (lot.val().available === 'soldout') {
								mapCoordVal['preFillColor'] =
									'rgba(255, 0, 0, 0.47)';
								mapCoordVal['name'] = 'soldout';
							}
							if (lot.val().available === 'available') {
								mapCoordVal['preFillColor'] = '';
								mapCoordVal['name'] = mapCoordVal['id'];
							}
							if (lot.val().available === 'pending') {
								mapCoordVal['preFillColor'] =
									'rgba(255, 255, 168, 0.70)';
								mapCoordVal['name'] = 'pending';
							}
							if (lot.val().available === 'hold') {
								mapCoordVal['preFillColor'] =
									'rgba(97, 97, 97, 1)';
								mapCoordVal['disabled'] = true;
								mapCoordVal['name'] = 'hold';
							}
						}

						mapCoordObj = {
							...mapCoords,
							areas: areaArr,
						};
					});

					setMapCoords(mapCoordObj);
				});
		}
		getData();
	}, []);

	const handleClickLot = (area) => {
		if (
			location.pathname === '/doc' &&
			(area.name === 'soldout' || area.name === 'pending')
		) {
			setStayHighlighted(false);
		} else {
			if (lotActive !== null || location.state.edit === true) {
				if (lotActive) {
					console.log(
						'set to available from doc',
						lotActive.lotSelected
					);
					handleClearLotInfo(lotActive.lotSelected);
				} else {
					console.log(
						'set to available from client',
						location.state.lot
					);
					handleClearLotInfo(location.state.lot);
				}
			}

			var lotSelected = area.id;
			if (lotSelected) {
				console.log('lotSelected 117', lotSelected);

				firebase
					.database()
					.ref(
						'/kavtek_clients/' +
							PROJECT_CODE.projectCode +
							'/lots/' +
							lotSelected
					)
					.once('value', (snapshot) => {
						var buildingArr = [];
						var buildingDetails;
						var buildingInfo;
						var availability = area.name;

						var buildingsArray = [];
						var finalBuildingArr = [];

						var buildingRef = snapshot.child('buildings');
						console.log('buildingRef: ', buildingRef);
						buildingRef.forEach((snap) => {
							snap.forEach((building) => {
								buildingsArray.push(building.key);
								buildingDetails = {
									name: building.key,
									buildingLot: lotSelected,
									price: building.val().priceList,
									sqft: building.val().sqft,
									buildingPrice: building.val().buildingPrice,
									soldout: building.val().soldout,
									available: availability,
									block: snapshot.val()?.block,
								};
								buildingArr.push(buildingDetails);
							});
						});
						console.log('buildingDetails: ', buildingArr);
						console.log('buildingsArray: ', buildingsArray);

						buildingArr &&
							buildingsArray.forEach((building) => {
								firebase
									.database()
									.ref(
										'/kavtek_clients/' +
											PROJECT_CODE.projectCode +
											'/buildingInfo/' +
											building
									)
									.once('value', (snapshot) => {
										buildingInfo = {
											name: building,
											price: snapshot.val().buildingPrice,
											sqft: snapshot.val().sqft,
											buildingPrice:
												snapshot.val().priceList,
											buildingLot:
												buildingDetails.buildingLot,
											soldout: buildingDetails.soldout,
											available:
												buildingDetails.availability,
										};

										finalBuildingArr.push(buildingInfo);
									});
							});

						console.log('buildingArray snapshot', finalBuildingArr);

						setLotList(buildingArr);
					});
			}

			var lotObj;

			firebase
				.database()
				.ref(
					'/kavtek_clients/' +
						PROJECT_CODE.projectCode +
						'/lots/' +
						lotSelected
				)
				.once('value', (snapshot) => {
					var lotPrice = snapshot.val()?.lotPrice
						? snapshot.val().lotPrice
						: 0;
					var availability = snapshot.val()?.available;
					var premiumDescription = snapshot.val()?.premiumDescription;

					console.log('availabilityavailability', snapshot.val());
					lotObj = {
						price: lotPrice,
						availability: availability,
						lot: lotSelected,
						center: area.center,
						premiumDescription: premiumDescription,
					};

					setLotPrice(lotPrice);

					setClickLotInfo(lotObj);
				});

			var buildingPriceList = [];
			var lotPriceList = [];
			firebase
				.database()
				.ref(
					'/kavtek_clients/' +
						PROJECT_CODE.projectCode +
						'/buildingInfo/'
				)
				.once('value', (snapshot) => {
					snapshot.forEach((snap) => {
						var priceList = snap.val().buildingPrice;
						buildingPriceList.push(priceList);
						var priceListRef = snap.child('priceList');

						priceListRef.forEach((priceLot) => {
							var lotPrice = priceLot.val().price;
							lotPriceList.push(lotPrice);
						});
					});

					var lotSum = lotPriceList.reduce(function (a, b) {
						return a + b;
					}, 0);

					setLotPriceSum(lotSum);

					var sum = buildingPriceList.reduce(function (a, b) {
						return a + b;
					}, 0);

					console.log('this is the sum ', sum);

					setBuildingPriceSum(sum);
				});
		}
	};

	const enterArea = (area) => {
		setHoveredArea(area);
	};

	const handleCloseTooltip = () => {
		setClickLotInfo();
	};

	const toolTipStyle = (top, left) => {
		console.log('toolTipStyle', top);
		return {
			top: `${top}px`,
			left: `${left + 90}px`,
		};
	};

	return (
		<div className='lots_wrapper'>
			<div className='siteplan_wrapper doc_card'>
				<div className='card_title'>Site Plan</div>
				<div className='legend_group'>
					{legendData.map((legend) => (
						<div className='legend_label_group'>
							<div
								className='legend_status'
								style={{
									marginTop: '5px',
									color: `${legend.color}`,
								}}
							>
								{legend.icon}
							</div>
							<div className='legend_label'>{legend.label}</div>
						</div>
					))}

					{userType === 'cobroker' && (
						<div className='legend_label_group'>
							<div
								className='legend_status'
								style={{
									marginTop: '5px',
									color: '#ccc',
								}}
							>
								<StopIcon />
							</div>
							<div className='legend_label'>Locked</div>
						</div>
					)}
				</div>
				{!mapCoords.areas ? (
					<div className={styles.mapImage}>
						<CircularProgress />
					</div>
				) : (
					<>
						<ImageMapper
							src={siteplan}
							map={mapCoords}
							stayHighlighted={stayHighlighted}
							areaKeyName={mapCoords.areas.id}
							fillColor={'rgba(71, 131, 230, 0.70)'}
							strokeColor={'rgba(71, 131, 230)'}
							onMouseEnter={(area) => {
								enterArea(area);
							}}
							onClick={(area) => {
								handleClickLot(area);
							}}
						/>
						{clickLotInfo && (
							<span
								className='tooltip-click'
								style={{
									...toolTipStyle(
										clickLotInfo?.center[1],
										clickLotInfo?.center[0]
									),
								}}
							>
								{clickLotInfo && (
									<div className='tooltip-content'>
										<div
											className='close-tooltip'
											onClick={handleCloseTooltip}
										>
											<CloseIcon />
										</div>
										<h1>Lot {clickLotInfo?.lot}</h1>
										<p>
											Lot Status:{' '}
											{clickLotInfo?.availability}
										</p>
										<p>Premium: $ {clickLotInfo?.price}</p>
										{clickLotInfo?.premiumDescription && (
											<p>
												Premium Description:{' '}
												{
													clickLotInfo?.premiumDescription
												}
											</p>
										)}
									</div>
								)}
							</span>
						)}
					</>
				)}
			</div>
		</div>
	);
}

const mapStateToProps = (state) => ({
	userType: state.signIn.userType,
	userDetails: state.signIn,
});

export default connect(mapStateToProps)(Lots);
